document.addEventListener("DOMContentLoaded", function () {
  const mainContent = document.querySelector(".main-content");
  const customerNameSelection = document.getElementById("name-selection");
  const giftSelection = document.getElementById("gift-selection");
  const birthdaySelection = document.getElementById("birthday-selection");

  const letsBeginBtn = document.getElementById("lets-begin");
  const findForSomeoneBtn = document.getElementById("find-for-someone");

  const customerNameTitle = document.getElementById("name-title");
  const customerName = document.getElementById("name-input");

  const nameNextBtn = document.getElementById("name-next-btn");
  const confirmPersonalityBtn = document.getElementById(
    "confirmPersonalityBtn"
  );
  const askMorePersonalityBtn = document.getElementById("ask-more-btn");
  const individualCharmsBtn = document.getElementById("individualCharmsBtn");

  const dayInput = document.getElementById("day-input");
  const monthInput = document.getElementById("month-input");
  const yearInput = document.getElementById("year-input");

  const giftOptions = document.querySelectorAll(".gift-option");
  const baseCards = document.querySelectorAll(
    "#baseSelectionPage .selection-option"
  );
  const budgetCards = document.querySelectorAll(
    "#budgetSelectionPage .selection-option"
  );
  const birthdayTitle = document.getElementById("birthday-title");

  let userPath = "self";
  let selectedGift = null;
  let quizData = null;
  let resultTally = {};
  let finalResult = null;
  let userInitials = null;
  let userZodiac = null;
  let userBirthMonth = null;
  let personalityTypesData = {
    "Bold Visionary": {
      title: "Bold Visionary",
      description: "You're Confident, Ambitious, Dynamic, and Radiate Power.",
      subdescription1:
        "You stride through life with magnetic energy, always ready to lead and inspire. Your presence commands attention and sparks change.",
      subdescription2:
        "Your style is a statement, bold and unapologetic. Choose jewelry that mirrors your fearless spirit and unstoppable drive.",
      collection_url: "/collections/bold-visionary",
    },
    "Playful Muse": {
      title: "Playful Muse",
      description: "You're Creative, Joyful, Spontaneous, and Full of Light.",
      subdescription1:
        "You dance through life with a spark of whimsy, spreading joy wherever you go. Your energy is infectious and uplifting.",
      subdescription2:
        "Your charms should capture your vibrant spirit. Pick pieces that are colorful, quirky, and as lively as your heart.",
      collection_url: "/collections/playful-muse",
    },
    "Mystic Dreamer": {
      title: "Mystic Dreamer",
      description:
        "You're Introspective, Enigmatic, Soulful, and Drawn to Mystery.",
      subdescription1:
        "You wander through life with a quiet curiosity, seeking depth and meaning. Your thoughts are a universe of their own.",
      subdescription2:
        "Your jewelry should reflect your inner world. Choose pieces that shimmer with celestial allure and hidden stories.",
      collection_url: "/collections/mystic-dreamer",
    },
    "Grounded Romantic": {
      title: "Grounded Romantic",
      description:
        "You're Intuitive, Heartfelt, Nostalgic, and Rooted in Meaning.",
      subdescription1:
        "You move through the world with quiet depth and an open heart. There's wisdom in your softness, and memory in your gaze.",
      subdescription2:
        "Your soul speaks in symbols, and your charms should too. Each one, a whisper of who you truly are and all you feel deeply.",
      collection_url: "/collections/grounded-romantic",
    },
    "Free-Spirit Adventurer": {
      title: "Free-Spirit Adventurer",
      description:
        "You're Curious, Bold, Independent, and Drawn to Exploration.",
      subdescription1:
        "You live for the thrill of discovery, chasing new horizons with untamed energy. The world is your playground, and you roam free.",
      subdescription2:
        "Your jewelry should echo your wanderlust. Choose pieces that carry the spirit of adventure and the call of the open road.",
      collection_url: "/collections/free-spirit",
    },
    "Serene Guardian": {
      title: "Serene Guardian",
      description: "You're Calm, Nurturing, Balanced, and a Source of Peace.",
      subdescription1:
        "You bring tranquility to every space, grounding those around you with your steady presence. Your strength lies in your calm.",
      subdescription2:
        "Your style should be simple yet meaningful. Choose jewelry that radiates peace and anchors your serene essence.",
      collection_url: "/collections/serene-guardian",
    },
    "Radiant Leader": {
      title: "Radiant Leader",
      description: "You're Inspiring, Confident, Visionary, and Born to Shine.",
      subdescription1:
        "You light up every room with your bold vision and unshakable confidence. Your energy inspires others to follow your lead.",
      subdescription2:
        "Your jewelry should match your radiance. Choose striking, luxurious pieces that reflect your commanding presence.",
      collection_url: "/collections/radiant-leader",
    },
  };

  const cat1Selection = document.getElementById("category1-selection");
  const cat2Selection = document.getElementById("category2-selection");
  const cat3Selection = document.getElementById("category3-selection");
  const cat4Selection = document.getElementById("category4-selection");
  const cat5Selection = document.getElementById("category5-selection");
  const cat6Selection = document.getElementById("category6-selection");

  function showLoader() {
      document.querySelector(".loader-overlay").classList.remove("hidden");
      document.body.classList.add("no-scroll");
  }

  function hideLoader() {
      document.querySelector(".loader-overlay").classList.add("hidden");
      document.body.classList.remove("no-scroll");
  }

  hideLoader();

  letsBeginBtn.addEventListener("click", function () {
    userPath = "self";
    customerNameTitle.innerHTML = "What's Your <br><span><i>Name?</i></span>";
    const userDetailsStr = localStorage.getItem("flo-user-details");
    if (userDetailsStr) {
      const userDetails = JSON.parse(userDetailsStr);
      document.getElementById("name-input").value = userDetails.name || "";
    }
    mainContent.style.display = "none";
    customerNameSelection.style.display = "block";
  });

  findForSomeoneBtn.addEventListener("click", function () {
    userPath = "gift";
    customerNameTitle.innerHTML = "What's Their <br><span><i>Name?</i></span>";
    mainContent.style.display = "none";
    giftSelection.style.display = "block";
  });

  nameNextBtn.addEventListener("click", () => {
    const nameValue = customerName.value.trim();

    if (userPath === "self") {
      birthdayTitle.innerHTML = "When's Your <br><span><i>Birthday?</i></span>";
    } else {
      birthdayTitle.innerHTML =
        "When's Their <br><span><i>Birthday?</i></span>";
    }

    if (nameValue === "") {
      nameInput.focus();
    } else {
      customerNameSelection.style.display = "none";
      birthdaySelection.style.display = "block";

      // set user initials
      const nameParts = nameValue.split(" ");
      userInitials = nameParts[0][0].toLowerCase();
    }

    fetch(window.quizJsonUrl)
      .then((res) => res.json())
      .then((data) => {
        quizData = data;
      })
      .catch((err) => console.error("Error loading quiz data:", err));
  });

  giftOptions.forEach((option) => {
    option.addEventListener("click", function () {
      giftOptions.forEach((opt) => opt.classList.remove("selected"));
      this.classList.add("selected");
      selectedGift = this.getAttribute("data-option");
      giftSelection.style.display = "none";
      customerNameSelection.style.display = "block";
    });
  });
  function getMonthName(month) {
    const months = [
      "january",
      "february",
      "march",
      "april",
      "may",
      "june",
      "july",
      "august",
      "september",
      "october",
      "november",
      "december",
    ];
    return months[month - 1] || null;
  }

  function getZodiacSign(day, month) {
    if ((month == 3 && day >= 21) || (month == 4 && day <= 19)) {
      return "aries";
    } else if ((month == 4 && day >= 20) || (month == 5 && day <= 20)) {
      return "taurus";
    } else if ((month == 5 && day >= 21) || (month == 6 && day <= 20)) {
      return "gemini";
    } else if ((month == 6 && day >= 21) || (month == 7 && day <= 22)) {
      return "cancer";
    } else if ((month == 7 && day >= 23) || (month == 8 && day <= 22)) {
      return "leo";
    } else if ((month == 8 && day >= 23) || (month == 9 && day <= 22)) {
      return "virgo";
    } else if ((month == 9 && day >= 23) || (month == 10 && day <= 22)) {
      return "libra";
    } else if ((month == 10 && day >= 23) || (month == 11 && day <= 21)) {
      return "scorpio";
    } else if ((month == 11 && day >= 22) || (month == 12 && day <= 21)) {
      return "sagittarius";
    } else if ((month == 12 && day >= 22) || (month == 1 && day <= 19)) {
      return "capricorn";
    } else if ((month == 1 && day >= 20) || (month == 2 && day <= 18)) {
      return "aquarius";
    } else if ((month == 2 && day >= 19) || (month == 3 && day <= 20)) {
      return "pisces";
    }
  }

  function validateBirthdayInput() {
    const day = parseInt(dayInput.value);
    const month = parseInt(monthInput.value);
    const year = parseInt(yearInput.value);

    if (isNaN(day) || isNaN(month) || isNaN(year)) return false;
    if (month < 1 || month > 12) return false;

    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) return false;

    const currentYear = new Date().getFullYear();
    if (year < 1900 || year > currentYear) return false;

    return true;
  }

  function checkBirthdayComplete() {
    if (
      dayInput.value.length === 2 &&
      monthInput.value.length === 2 &&
      yearInput.value.length === 4
    ) {
      if (!validateBirthdayInput()) {
        alert("Please enter a valid date");
        return;
      }

      birthdayData = {
        dd: dayInput.value,
        mm: monthInput.value,
        yyyy: yearInput.value,
      };
      loadQuizData(quizData);
      attachOptionListeners();
      setupNextButtons();
      birthdaySelection.style.display = "none";
      cat1Selection.style.display = "block";

      // user birth month
      userBirthMonth = getMonthName(birthdayData.mm);
      // calculate user zodiac
      userZodiac = getZodiacSign(birthdayData.dd, birthdayData.mm);
    }
  }

  dayInput.addEventListener("input", function () {
    this.value = this.value.replace(/[^0-9]/g, "").slice(0, 2);
    if (this.value.length === 2) monthInput.focus();
  });

  monthInput.addEventListener("input", function () {
    this.value = this.value.replace(/[^0-9]/g, "").slice(0, 2);
    if (parseInt(this.value) > 12) this.value = "12";
    if (this.value.length === 2) yearInput.focus();
  });

  yearInput.addEventListener("input", function () {
    this.value = this.value.replace(/[^0-9]/g, "").slice(0, 4);

    if (this.value.length === 4) {
      const currentYear = new Date().getFullYear();
      const enteredYear = parseInt(this.value);

      if (enteredYear > currentYear) this.value = currentYear.toString();
      if (enteredYear < 1900) this.value = "1900";

      checkBirthdayComplete();
    }
  });

  dayInput.addEventListener("keypress", function (e) {
    if (e.key === "Enter" && this.value.length >= 1) monthInput.focus();
  });

  monthInput.addEventListener("keypress", function (e) {
    if (e.key === "Enter" && this.value.length >= 1) yearInput.focus();
  });

  yearInput.addEventListener("keypress", function (e) {
    if (e.key === "Enter" && this.value.length === 4) checkBirthdayComplete();
  });

  function loadQuizData(quiz) {
    function renderCategory(containerId, category, variation) {
      const section = document.getElementById(`${containerId}-selection`);
      if (!section) return;

      const titleEl = section.querySelector("p");
      if (titleEl) {
        titleEl.innerHTML = category.title;
        titleEl.style.display = "none";
      }

      const descEl = section.querySelector("h2");
      if (descEl) descEl.innerHTML = variation.question || "";

      const optionsWrapper = section.querySelector(`.${containerId}-options`);
      if (optionsWrapper) {
        optionsWrapper.innerHTML = "";

        variation.options.forEach((opt, idx) => {
          const div = document.createElement("div");
          div.className = `${containerId}-option`;
          div.setAttribute(`data-${containerId}`, `opt-${idx}`); // Simplified data attribute

          // Create image element
          const img = document.createElement("img");
          img.src = opt.img_url || "https://via.placeholder.com/150"; // Fallback image
          img.alt = opt.text;
          img.className = "option-image";
          img.loading = "lazy";

          // Create text span
          const span = document.createElement("span");
          span.textContent = opt.text;

          const optionCircle = `
            <div class="ai-tick4options">
              <div class="tickOuter">
                <div class="tickInner"></div>
              </div>
            </div>
          `
          const temp = document.createElement("div");
          temp.innerHTML = optionCircle;

          // Append image and text to the option div
          div.appendChild(img);
          div.appendChild(temp.firstElementChild);
          div.appendChild(span);

          // Add click event listener for selection
          div.addEventListener("click", () => selectOption(div, containerId));

          optionsWrapper.appendChild(div);
        });
      }
    }
    function randomPick(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }

    const cat1 = {
      title: quiz.category1.title,
      ...randomPick(quiz.category1.variations),
    };
    renderCategory("category1", quiz.category1, cat1);

    const cat2 = {
      title: quiz.category2.title,
      ...randomPick(quiz.category2.variations),
    };
    renderCategory("category2", quiz.category2, cat2);

    const cat3 = {
      title: quiz.category3.title,
      ...randomPick(quiz.category3.variations),
    };
    renderCategory("category3", quiz.category3, cat3);

    const cat4 = {
      title: quiz.category4.title,
      ...randomPick(quiz.category4.variations),
    };
    renderCategory("category4", quiz.category4, cat4);

    const cat5 = {
      title: quiz.category5.title,
      ...randomPick(quiz.category5.variations),
    };
    renderCategory("category5", quiz.category5, cat5);

    const cat6 = {
      title: quiz.category6.title,
      ...randomPick(quiz.category6.variations),
    };
    renderCategory("category6", quiz.category6, cat6);
  }

  function selectOption(el, categoryKey) {
    document
      .querySelectorAll(`.${categoryKey}-option`)
      .forEach((opt) => opt.classList.remove("selected"));

    el.classList.add("selected");

    // store the selected text in dataset for later tallying
    const selectedText = el.innerText.trim();
    const container = document.getElementById(`${categoryKey}-selection`);
    container.setAttribute("data-selected", selectedText);
  }

  function getFinalResult() {
    let winner = null;
    let maxCount = 0;

    for (let [key, count] of Object.entries(resultTally)) {
      if (count > maxCount) {
        maxCount = count;
        winner = key;
      }
    }
    return winner;
  }

  function attachOptionListeners() {
    document.querySelectorAll(".category1-option").forEach((option) => {
      option.addEventListener("click", function () {
        selectOption(this, "category1");
      });
    });

    document.querySelectorAll(".category2-option").forEach((option) => {
      option.addEventListener("click", function () {
        selectOption(this, "category2");
      });
    });

    document.querySelectorAll(".category3-option").forEach((option) => {
      option.addEventListener("click", function () {
        selectOption(this, "category3");
      });
    });

    document.querySelectorAll(".category4-option").forEach((option) => {
      option.addEventListener("click", function () {
        selectOption(this, "category4");
      });
    });

    document.querySelectorAll(".category5-option").forEach((option) => {
      option.addEventListener("click", function () {
        selectOption(this, "category5");
      });
    });

    document.querySelectorAll(".category6-option").forEach((option) => {
      option.addEventListener("click", function () {
        selectOption(this, "category6");
        console.log("logged btn 6");
      });
    });
  }

  function setupNextButtons() {
    const categories = [
      {
        btn: "cat1-next-btn",
        catId: "category1",
        current: "category1-selection",
        next: "category2-selection",
      },
      {
        btn: "cat2-next-btn",
        catId: "category2",
        current: "category2-selection",
        next: "category3-selection",
      },
      {
        btn: "cat3-next-btn",
        catId: "category3",
        current: "category3-selection",
        next: "category4-selection",
      },
      {
        btn: "cat4-next-btn",
        catId: "category4",
        current: "category4-selection",
        next: "category5-selection",
      },
      {
        btn: "cat5-next-btn",
        catId: "category5",
        current: "category5-selection",
        next: "category6-selection",
      },
      {
        btn: "cat6-next-btn",
        catId: "category6",
        current: "category6-selection",
        next: null,
      },
    ];

    categories.forEach((cat) => {
      const btn = document.getElementById(cat.btn);
      btn.disabled = true; // lock initially

      // enable once option clicked
      document.querySelectorAll(`.${cat.catId}-option`).forEach((opt) => {
        opt.addEventListener("click", () => {
          btn.disabled = false;
        });
      });

      btn.addEventListener("click", () => {
        // tally the result for this category
        const section = document.getElementById(cat.current);
        const selectedText = section.getAttribute("data-selected");

        if (selectedText) {
          const categoryData = quizData[cat.catId];
          categoryData.variations.forEach((variation) => {
            variation.options.forEach((opt) => {
              if (opt.text.trim() === selectedText) {
                opt.result.forEach((r) => {
                  resultTally[r] = (resultTally[r] || 0) + 1;
                });
              }
            });
          });
        }

        // hide current and move to next
        document.getElementById(cat.current).style.display = "none";

        if (cat.next) {
          document.getElementById(cat.next).style.display = "block";
        } else {
          // final result
          finalResult = getFinalResult();
          setPersonalityType(finalResult);
          document.getElementById("personalitymodel").style.display = "block";

          // style me button update
          const btn = document.getElementById("styleMeBtn");
          btn.onclick = () => {
            let baseUrl = personalityTypesData[finalResult].collection_url;
            baseUrl += baseUrl.includes("?")
              ? "&ai-quiz=true"
              : "?ai-quiz=true";
            window.location.href = baseUrl;
          };

          // save user data
          const quizCategorySelections = {};
          for (let i = 1; i <= 6; i++) {
            const el = document.getElementById(`category${i}-selection`);
            if (el) {
              quizCategorySelections[`category${i}`] = el.getAttribute("data-selected");
            }
          }
          let floUserDetails = null;
          const userDetailsStr = localStorage.getItem("flo-user-details");
          if (userDetailsStr) {
            try {
              floUserDetails = JSON.parse(userDetailsStr);
            } catch (e) {
              console.error("Invalid flo-user-details JSON", e);
            }
          }
          const userData = {
            personalityType: finalResult,
            userZodiac: userZodiac,
            userInitials: userInitials,
            userBirthMonth: userBirthMonth,
            gifting: userPath == "gift",
            giftingOption: userPath == "gift" ? selectedGift : null,
            quizCategorySelections,
            userDetails: floUserDetails,
            deetscode: "YJxEla"
          };
          localStorage.setItem("userData", JSON.stringify(userData));
          submitQuizData(userData);
        }
      });
    });
  }

  async function submitQuizData(userData){
    try {
      showLoader();
      const response = await fetch('https://yj-ai-quiz.vercel.app/api/user-data', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData)
      });
      
      const result = await response.json();
      
      if (result.success) {
        // console.log("Success");
      } else {
        // console.log("Failed");
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      hideLoader();
    }
  }

  function resetPersonalityQuiz() {
    quizData = null;
    resultTally = {};
    finalResult = null;

    document.querySelectorAll(".selected").forEach((el) => {
      el.classList.remove("selected");
    });

    [
      cat1Selection,
      cat2Selection,
      cat3Selection,
      cat4Selection,
      cat5Selection,
      cat6Selection,
    ].forEach((section) => {
      section.style.display = "none";
    });

    fetch(window.quizJsonUrl)
      .then((res) => res.json())
      .then((data) => {
        quizData = data;
        loadQuizData(quizData);
        attachOptionListeners();
        setupNextButtons();
        cat1Selection.style.display = "block";
      })
      .catch((err) => console.error("Error loading quiz data:", err));
  }

  function setPersonalityType(personality) {
    console.log("personality =========", personality);
    document.getElementById("personality-quiz-title").innerHTML =
      personalityTypesData[personality].title;
    document.getElementById("personality-quiz-description").innerHTML =
      personalityTypesData[personality].description;
    document.getElementById("personality-quiz-sub-description-1").innerHTML =
      personalityTypesData[personality].subdescription1;
    document.getElementById("personality-quiz-sub-description-1").style.display = "none";
    document.getElementById("personality-quiz-sub-description-2").innerHTML =
      personalityTypesData[personality].subdescription2;
  }

  if(confirmPersonalityBtn){    
    confirmPersonalityBtn.addEventListener("click", function () {
      document.getElementById("personalitymodel").style.display = "none";
      document.getElementById("stylemodel").style.display = "block";
    });
  }

  if(askMorePersonalityBtn){
    askMorePersonalityBtn.addEventListener("click", function () {
      document.getElementById("personalitymodel").style.display = "none";
      resetPersonalityQuiz();
      document.getElementById("category1-selection").style.display = "block";
    });
  }

  if (individualCharmsBtn) {
    individualCharmsBtn.addEventListener("click", function () {
      document.getElementById("stylemodel").style.display = "none";
      jewelryEmotionSection.style.display = "none";
      document.getElementById("baseSelectionPage").style.display = "block";
    });
  }

  baseCards.forEach((card) => {
    card.addEventListener("click", function () {
      document.getElementById("baseSelectionPage").style.display = "none";
      document.getElementById("budgetSelectionPage").style.display = "block";
    });
  });

  budgetCards.forEach((card) => {
    card.addEventListener("click", function () {
      const selectedBudget = this.getAttribute("data-selection");
      window.location.href = `/collections/all?filter=${selectedBudget}`;
    });
  });

  document.querySelectorAll(".emotion-model").forEach((model) => {
    model.addEventListener("click", function (e) {
      if (e.target === this) this.style.display = "none";
    });
  });

  const closeButtons = `
        <a class="close-stylist-modal">
          <span class="close-modal-badge close-custom-popup-modal-container">      
            <img width="" height="" class="close-custom-popup-modal image-size-of-quiz" src="https://cdn.shopify.com/s/files/1/0688/5120/4373/files/Group_184.png?v=1755710617" alt="Close popup">
          </span>
        </a>
    `;
  document.querySelectorAll(".semi-circle-images").forEach((content) => {
    content.insertAdjacentHTML("beforeend", closeButtons);
  });

  document.querySelectorAll(".close-stylist-modal").forEach((btn) => {
    btn.addEventListener("click", function () {
      window.location.reload();
    });
  });
});
